<template>
  <div class="box-aside line-top">
    <ul class="list-group menu-aside">
      <router-link tag="li" class="list-group-item" active-class="active" to="/adminpedidos">
        <a><i class="fa fa-cutlery"></i> <span>Pedidos</span> <i class="fa fa-angle-right"></i></a>
      </router-link>
      <router-link tag="li" to="/usuarios" exact class="list-group-item" active-class="active">
        <a><i class="fa fa-user"></i>  <span>Usuarios</span> <i class="fa fa-angle-right"></i></a>
        <ul class="subnav">
          <router-link tag="li" to="/newuser">
            <a>Nuevo usuario</a>
          </router-link>
          <router-link tag="li" to="/invitarusuarios">
            <a>Invitar usuario</a>
          </router-link>
        </ul>
      </router-link>
      <router-link tag="li" to="/historialempresa" active-class="active" class="list-group-item">
        <a>
          <i class="fa fa-list"></i>  <span>Historial Empresa</span> <i class="fa fa-angle-right"></i>
        </a>
      </router-link>
      <router-link tag="li" to="/usuarios/liquidaciones" active-class="active" class="list-group-item">
        <a>
          <i class="fa fa-list"></i>  <span>Liquidaciones</span> <i class="fa fa-angle-right"></i>
        </a>
      </router-link>
    </ul>
  </div>
</template>
<script>
  export default {}
</script>



// WEBPACK FOOTER //
// MenuLateralAdmin.vue?71c3908b